import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const records = (state: RootState) => state.patient.records;

export const selectSnooze = createSelector(
    [(_, id: string) => id, records],
    (id, records) => records[id]?.patient?.snooze
);
